
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.498 13.523l.049-.455.146-.407 2.44.813-.081-.406a1.007 1.007 0 00-.265-.427c-.154-.102-1.699-1.245-1.699-1.245a.355.355 0 01-.163-.239c.085-.35.146-.704.183-1.062V8.562c.041-.147.075-.296.102-.447 0-.138.032-.447.032-.447l1.196.301 5.017 1.964.045.158-.045-.598a.92.92 0 00-.256-.406l-2.114-1.452.053-.134h.077c.027-.134.042-.27.045-.407v-.406l-.033-.183-.045-.037h-.496l-.049.061-.02.118v.647l-1.378-.94v-.179h.077c.027-.133.042-.27.045-.406v-.407l-.033-.183-.045-.036h-.496l-.049.061-.02.118v.646l-1.517-1.22a.407.407 0 01-.13-.158c0-.061 0-1.424-.048-1.79a6.167 6.167 0 00-.257-1 .325.325 0 00-.323-.323.325.325 0 00-.323.323c-.114.326-.199.66-.256 1-.061.366-.045 1.729-.049 1.79a.407.407 0 01-.13.158l-1.517 1.22v-.646l-.02-.118-.049-.061h-.496l-.045.036-.032.183v.407c.002.136.017.273.044.406h.078v.179l-1.379.94v-.647l-.02-.118-.049-.061h-.496l-.045.037-.032.183v.406c.002.137.017.273.044.407h.163l.053.134L.801 9.05a.924.924 0 00-.256.407l-.045.598.045-.159 5.017-1.964 1.196-.301s0 .309.032.447c.027.151.061.3.102.448.042.147 0 1.22 0 1.533.037.357.098.712.183 1.061a.36.36 0 01-.163.24c-.085.053-1.545 1.142-1.699 1.244a1.014 1.014 0 00-.265.427l-.081.407 2.44-.814.146.407.045.492z"}})])
          )
        }
      }
    